import React, { useEffect, useState ,useRef} from "react";
import { motion } from "framer-motion";
import "./StatsSection.css";
import { FaIndustry, FaHandshake, FaFlask, FaShieldAlt } from "react-icons/fa";

const statsData = [
  { 
    id: 1, 
    value: 1982, 
    suffix: "", 
    label: "Founded with the vision to bridge industries with the right materials", 
    icon: <FaIndustry /> 
  },
  { 
    id: 2, 
    value: 40, 
    suffix: "+ Years", 
    label: "Spanning Southern India", 
    icon: <FaHandshake /> 
  },
  { 
    id: 3, 
    value: 1000, 
    suffix: "+", 
    label: "Plating and Specialty Chemicals, Basic and Lab Chemicals, Metals, Abrasives, Cutting Tools, Wood & Glass Coatings, Metal Coatings", 
    icon: <FaFlask /> 
  },
  { 
    id: 4, 
    value: 50, 
    suffix: " + Partner", 
    label: "More than a supplier — a partner in progress & reliability", 
    icon: <FaShieldAlt /> 
  },
];

const Counter = ({ value, suffix }) => {
  const [count, setCount] = useState(0);
  const [hasStarted, setHasStarted] = useState(false);
  const counterRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHasStarted(true);
          observer.disconnect(); // stop observing once started
        }
      },
      { threshold: 0.5 } // trigger when 50% of the element is visible
    );

    if (counterRef.current) {
      observer.observe(counterRef.current);
    }

    return () => {
      if (counterRef.current) observer.unobserve(counterRef.current);
    };
  }, []);

  useEffect(() => {
    if (!hasStarted) return;

    let start = 0;
    const end = value;
    const duration = 2000;
    const incrementTime = 20;
    const steps = duration / incrementTime;
    const stepValue = end / steps;

    const counter = setInterval(() => {
      start += stepValue;
      if (start >= end) {
        start = end;
        clearInterval(counter);
      }
      setCount(Number(start.toFixed(2)));
    }, incrementTime);

    return () => clearInterval(counter);
  }, [hasStarted, value]);

  return (
    <span ref={counterRef}>
      {count}
      {suffix}
    </span>
  );
};


const StatsSection = () => {
  return (
    <section className="stats-section">
      {/* Floating Dots */}
      <motion.div
        className="floating-dot orange"
        animate={{ y: [0, -20, 0] }}
        transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="floating-dot blue"
        animate={{ y: [0, 25, 0] }}
        transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="floating-dot green"
        animate={{ y: [0, -15, 0] }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="floating-dot red"
        animate={{ y: [0, 30, 0] }}
        transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
      />

      {/* Title */}
      <div className="stats-header">
        <h2>
          Our Journey <span>Through the Industry</span>
        </h2>
      </div>

      {/* Stats */}
      <div className="stats-grid">
        {statsData.map((stat, idx) => (
          <motion.div
            key={stat.id}
            className="stat-card"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: idx * 0.2 }}
            viewport={{ once: true }}
            whileHover={{ scale: 1.05 }}
          >
            <div className="stat-icon">{stat.icon}</div>
            <div>
            <h3>
              <Counter value={stat.value} suffix={stat.suffix} />
            </h3>
            <p>{stat.label}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default StatsSection;
